<mojo-viewbar></mojo-viewbar>
<mojo-page-title title="Email Templates"></mojo-page-title>

  <section class="panel data-table full-page-widget mojo-admin-page full-page-scrollable">
    <div class="panel-body">
      <mojo-email-templates-table [emailTemplates]="emailTemplates | async" [loading]="loading | async" (onRowClicked)="onRowClick($event)"></mojo-email-templates-table>
    </div>
  </section>

<mojo-email-template-editor #editor></mojo-email-template-editor>
